import React from 'react';
import { StyledInput, Label, Container } from './styles';

function Select({
  icon,
  placeholder,
  label,
  value,
  onChange,
  width,
  disabled,
  disableLabel,
  marginVertical,
  onFocus,
  height,
  success,
  error,
  children,
  ...props
}) {
  return (
    <Container width={width} {...props}>
      {!disableLabel && <Label>{label}:</Label>}

      <StyledInput
        success={success}
        error={error}
        height={height}
        icon={icon && true}
        width={width}
        marginVertical={marginVertical}
        disabled={disabled}
      >
        {icon && <div>{icon}</div>}
        <select value={value} placeholder={placeholder} onFocus={onFocus} onChange={onChange} disabled={disabled}>
          {children}
        </select>
      </StyledInput>
    </Container>
  );
}

export default Select;
